import { CheckCircle, Copy, Download, Edit3, Mail, MessageCircle, FileText, PhoneCall } from "lucide-react";

export default function Success({ data, restart }) {
  return (
    <div className="success-page">
      <div className="success-banner">
        <div className="container success-hero">
          <div>
            <div className="success-icon"><CheckCircle size={48} /></div>
            <h1>Quote Request <span>Submitted!</span></h1>
            <h3>Thank you for choosing <b>Natural Packers & Movers.</b></h3>
            <p>We have received your quotation request and our team will review the details.<br />You will receive a confirmation on WhatsApp, email or phone shortly.</p>
          </div>
          <div className="success-art">👨🏻‍🔧 📦 🚚</div>
        </div>
      </div>

      <div className="container success-grid">
        <main className="form-card">
          <div className="reference">
            <Mail size={28} /><div>Your Quote Reference No.<strong>NPMQ-20260916-001</strong></div><Copy size={18} />
            <span>Request Received</span>
          </div>
          <h2>What Happens Next?</h2>
          <div className="next-steps">
            {[
              ["✉", "Request Received", "We have received your quotation request."],
              ["♙", "Our Team Reviews", "Our team will review your details and calculate the best quote."],
              ["☎", "We'll Get in Touch", "You will receive a call, WhatsApp or email from our team shortly."],
              ["▤", "Get Your Final Quote", "We will share a customized quotation with the best price and timeline."]
            ].map(([i, t, d], idx) => <div className="next-step" key={t}><div className="next-icon">{i}<small>{idx + 1}</small></div><strong>{t}</strong><p>{d}</p></div>)}
          </div>
          <div className="whatsapp-banner"><MessageCircle size={30} /><div><strong>Prefer WhatsApp Communication?</strong><span>Get faster updates and your quotation directly on WhatsApp.</span></div><button>Chat on WhatsApp</button></div>
        </main>

        <aside className="form-card confirmation-card">
          <h3>A confirmation has been sent to you</h3>
          <div className="confirm-methods"><div><Mail size={18} /><strong>Email</strong><span>{data.email || "your@email.com"}</span></div><div><MessageCircle size={18} /><strong>WhatsApp</strong><span>{data.whatsapp || data.phone || "+91 98765 43210"}</span></div></div>
          <h3>Quick Actions</h3>
          <button className="quick"><FileText /><div><strong>Download Summary</strong><span>Save a copy of your request details</span></div><Download /></button>
          <button className="quick"><Edit3 /><div><strong>Edit Quote Request</strong><span>Need to make changes? You can edit your request.</span></div><span>→</span></button>
          <button className="quick"><PhoneCall /><div><strong>Contact Us</strong><span>Have questions? Talk to our support team.</span></div><span>→</span></button>
          <button className="restart" onClick={restart}>Create Another Quote</button>
        </aside>
      </div>
    </div>
  );
}
